import React from 'react';
import { withTranslation } from 'react-i18next';
import {
    Grid,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
    Button,
    CircularProgress,
    Box,
} from '@mui/material';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import { COLORS } from '../../../utils/Application_Constants';
import WithContexts from '../../../contexts/withContexts';

const styles = (theme) => ({
    text: {
        color: COLORS.DENIM,
        fontWeight: '700',
        [theme.breakpoints.down('md')]: {
            display: 'flex',
        },
        buttonWrapper: {
            borderTop: `1px solid ${COLORS.SEASHELL}`,
            display: 'flex',
            justifyContent: 'flex-end',
            [theme.breakpoints.down('md')]: {
                justifyContent: 'center',
            },
        },
        button: {
            marginRight: '42px',
            marginTop: '25px',
            [theme.breakpoints.down('md')]: {
                width: '100%',
                margin: '20px 32px',
            },
        },
    },
    loadingContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
    },
});

function RequiredQuestionDialog({
    classes,
    t,
    open,
    title,
    text,
    buttonTexts,
    buttonIDs,
    onClose,
    disableBackgroundClick,
    isLoading,
    buttonVariants,
    preserveWhitespace,
}) {
    const renderButtons = (buttonText, buttonIds, variants) => {
        const buttonArr = buttonText.split(';');
        const buttonIdArr = buttonIds.split(';');
        const variantArr = variants ? variants.split(';') : [];
        return (
            <>
                {buttonArr.map((btnName, index) => (
                    <Grid key={index} item classes={{ root: classes.saveButtonWrapper }}>
                        <Button
                            onClick={() => handleClose(buttonIdArr[index])}
                            variant={variantArr[index] || 'contained'}
                            color="primary"
                            id={`dialog-btn-${index}`}
                            className={classes.button}
                            disabled={isLoading}
                        >
                            {btnName}
                        </Button>
                    </Grid>
                ))}
            </>
        );
    };

    const handleClose = (buttonPressed) => {
        onClose(buttonPressed);
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={classes.text}
            disableEscapeKeyDown
        >
            {title !== '' ? <DialogTitle>{title}</DialogTitle> : ''}
            <DialogContent>
                {isLoading ? (
                    <Box className={classes.loadingContainer}>
                        <CircularProgress size={24} />
                        <DialogContentText>Saving changes...</DialogContentText>
                    </Box>
                ) : (
                    <DialogContentText
                        style={preserveWhitespace ? { whiteSpace: 'pre-wrap' } : undefined}
                    >
                        {text}
                    </DialogContentText>
                )}
            </DialogContent>
            <DialogActions>{renderButtons(buttonTexts, buttonIDs, buttonVariants)}</DialogActions>
        </Dialog>
    );
}

RequiredQuestionDialog.propTypes = {
    classes: PropTypes.shape({
        text: PropTypes.string.isRequired,
    }).isRequired,
    onClose: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    title: PropTypes.string,
    buttonTexts: PropTypes.string.isRequired,
    buttonIDs: PropTypes.string.isRequired,
    isLoading: PropTypes.bool,
    buttonVariants: PropTypes.string,
    preserveWhitespace: PropTypes.bool,
};

export default WithContexts(withTranslation()(withStyles(styles)(RequiredQuestionDialog)));
